import { useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import { GridStackRender } from "./grid-stack-render";
import { useGridStackContext } from "../../../../contexts/grid-stack-context";
import { panelContentMap } from "./panels/constants";
import { ConfigurePanelDialog } from "./panels/ConfigurePanelDialog/ConfigurePanelDialog";
import { useDispatch } from "react-redux";
import {
  queries,
  actions,
} from "../../../../redux/features/account/accountSlice";

import "gridstack/dist/gridstack.css";
import "./GridStack.css";

export function GridStack({ stream, tabId }) {
  const dispatch = useDispatch();
  const { instance } = useGridStackContext();
  const [configOpen, setConfigOpen] = useState(false);

  const handleOpenConfig = async () => {
    dispatch(actions.reset());
    dispatch(actions.setTabMetadata({ stream, tabId }));
    await dispatch(queries.getPanelInitialInfo());
    setConfigOpen(true);
    dispatch(queries.loadAllPredefinedPanels());
  };

  const handleCloseConfig = () => {
    setConfigOpen(false);
  };

  return (
    <>
      <Toolbar onConfigureClick={handleOpenConfig} />
      {/* <div ref={instance.ref} id="grid-stack-container-ref"> */}
      {instance.value ? (
        <GridStackRender componentMap={panelContentMap} workstream={stream} />
      ) : null}
      {/* </div> */}
      <ConfigurePanelDialog isOpen={configOpen} onClose={handleCloseConfig} />
    </>
  );
}

function Toolbar({ onConfigureClick }) {
  const { events } = useGridStackContext();

  return (
    <div className="gridstack-btns-container">
      {/* <Tooltip
        title={"+ New Panel"}
        placement="left"
        slotProps={{
          tooltip: { className: "rounded-tooltip bg-green-tooltip" },
        }}
      >
        <button className="gridstack-add-panel-btn" onClick={events.onAddPanel}>
          <span className="icon-add-panel" />
        </button>
      </Tooltip> */}
      <Tooltip
        title={"+ Predefined panel"}
        placement="left"
        slotProps={{
          tooltip: { className: "rounded-tooltip bg-dark-tooltip" },
        }}
      >
        <button
          className="gridstack-add-panel-btn gridstack-add-configure-panel-btn"
          onClick={onConfigureClick}
        >
          <span className="icon-add-configure-panel" />
        </button>
      </Tooltip>
    </div>
  );
}
